import { useCallback, useEffect, useRef, useState } from "react";

export default function useToggle(
  initialValue: boolean,
  callback?: (newVal: boolean) => void
): [boolean, () => void] {
  const [value, setValue] = useState(initialValue);
  const toggle = useCallback(() => {
    setValue((val) => !val);
  }, [setValue]);
  const isFirstRun = useRef<boolean>(true);
  useEffect(() => {
    if (typeof callback === "function") {
      if (isFirstRun.current) {
        // Skip the first run,
        // callback should only fire on subsequent change
        isFirstRun.current = false;
        return;
      }
      callback(value);
    }
  }, [callback, value]);
  return [value, toggle];
}
